module.exports = __webpack_public_path__ + "static/media/server.0b5d7f4f.jpg";